export default {
    fileUploadRam: {
        page: {
            Maximum: 'Maximum capacity',
            limit: 'File Size Limit',
            details: 'View Configuration Details',
            Used: 'Used Capacity',
            discard: 'Do you want to adiscard the current page data and retrieve it again?',
            saving: 'You are saving current data, do you want to continue?'
        },
    },
};
